import type { AppId } from 'constants/known-apps';
import knownApps, {
  ASANA,
  AZURE_AD,
  customOptionApps,
  GITHUB,
  HARVEST,
  PHONE_CALLS,
  TIMELY_GPS_TRACKER,
  TODOIST,
  TOGGL,
} from 'constants/known-apps';
import type { FactoryApp } from 'factories/apps';
import type { App } from 'types/apps';

export const getAppSubtitle = (id: string, provider: string) => {
  const noSubtitleApps: Array<string> = [GITHUB, TODOIST, ASANA];
  const timelyMobileApps: Array<string> = [PHONE_CALLS, TIMELY_GPS_TRACKER];

  if (timelyMobileApps.includes(id)) {
    return 'Via Timely mobile app';
  }

  if (noSubtitleApps.includes(id) || !provider) {
    return null;
  }

  return `From ${provider}`;
};

export const getAppImportDetails = (id: string) => {
  const integrationApps: Array<string> = [TOGGL, HARVEST];

  if (integrationApps.includes(id)) {
    return 'Projects, Clients, Tags, Users.';
  }
};

export const getAppsFilteredByName = (apps: Array<FactoryApp>, name: string) =>
  apps.filter(app => {
    if (!name) return true;

    const appName = app.displayName.toLowerCase();
    const filter = name.toLowerCase();

    return appName.includes(filter);
  });

export const isAppConnected = (appId: AppId, apps: Array<App | FactoryApp>) =>
  apps.some(app => app.id === appId && app.integrated);

export function getAppDeleteWarning(
  appId: string,
  accountType: string,
  displayName: string
): string {
  if (appId === AZURE_AD) {
    return 'This will disable Azure AD sign-on and stop the synchronisation of users between this workspace and Azure AD.';
  }

  if (customOptionApps.includes(appId as AppId)) {
    return `You will stop receiving updated data from ${displayName}. No current imported data will be lost.`;
  }

  if ((knownApps.trackers as ReadonlyArray<string>).includes(appId)) {
    return 'This will delete your entire history of tracked memories.';
  }

  return `This will delete all unlogged draft time entries for past ${accountType} events.`;
}
